import { render, staticRenderFns } from "./Allergies.vue?vue&type=template&id=3f3061bf&scoped=true"
import script from "./Allergies.vue?vue&type=script&lang=js"
export * from "./Allergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3061bf",
  null
  
)

export default component.exports